import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import axios from 'axios';
import auth from '@feathersjs/authentication-client';

let client = null;

function createClient() {
  const restClient = rest(window.__RUNTIME_CONFIG__.REACT_APP_API_URL);
  const app = feathers().configure(restClient.axios(axios));
  app.configure(
    auth({
      storageKey: 'auth',
      storage: window.localStorage,
    })
  );
  app.hooks({
    before: {
      all: [
        (context) => {
          const token = window.localStorage.getItem('auth');
          context.params.headers = {
            ...(context.params.headers || {}),
            Authorization: token ? `Bearer ${token}` : '',
            'Content-Type': 'multipart/form-data',
          };
          return context;
        },
      ],
    },
  });

  return app;
}

export function getRestClient() {
  if (!client) client = createClient();
  return client;
}

export function getRestService(serviceName) {
  return getRestClient().service(serviceName);
}

export function resetRestClient() {
  client = null;
}
